// extracted by mini-css-extract-plugin
module.exports = {"customCheckBox":"CustomCheckboxV2_customCheckBox__Addqy","dark":"CustomCheckboxV2_dark__VoOWv","green":"CustomCheckboxV2_green__1-ROo"};